import React from "react";
import { ExtraProps } from "../../../schemed/FormControlProps";
import { usePowerEditorSettings } from "../../PowerEditorSettingsContext";
import { PowerEditorBase } from "../../slate/PowerEditorBase";
import { Schema } from "../../../../hooks/useSchema";
import { PreconfiguredField } from "./usePreconfiguredFields";
import { FormControl } from "../../../schemed";

interface Field {
  label: string;
  value: string;
}

interface PreconfiguredEditorProps {
  schema: Schema;
  field: PreconfiguredField;
  fields: Record<string, Field>;
  updateField: (code: string, changes: Partial<Field>) => void;
}

const EmptyX = {};

const DefaultPreconfigureExtraProps: ExtraProps = { autoComplete: true, label: " " };

export const PreconfiguredEditor = (props: PreconfiguredEditorProps) => {
  const { field: f, schema, fields, updateField } = props;
  const settings = usePowerEditorSettings();
  const EditorComponent = settings.EditorComponent || PowerEditorBase;

  if(f.type === "powerdoc") {
    return (
      <EditorComponent
        key={f.code}
        content={fields[f.code]?.value}
        update={v => updateField(f.code, { label: f.code, value: v })}
        />)
  }
  return (
    <FormControl
      field="value"
      row={fields[f.code] || EmptyX}
      extraProps={DefaultPreconfigureExtraProps}
      schema={schema[f.code]}
      onChange={(o,c) => updateField(f.code, { label: f.code, value: c.value })}
      />
  );
}
